var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 405,
    height: 289,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0{fill:#000}.s1{stroke:#000;stroke-width:4}.s1,.s2,.s3{fill:none;stroke-linecap:round}.s2{stroke:#000;stroke-width:2}.s3{stroke:#1f161e}.s4{fill:#78e5e1}.s5{fill:#d8d8d8}.s6{fill:#969696}.s8{fill:#fff}.s9{fill:none;stroke:#969696;stroke-linecap:round;stroke-linejoin:round;stroke-width:.8}.s11{fill:#ab8de5}.s12{fill:#1f161e}.s16{fill:#f8cdba}.s17{fill:#fa9e9f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M136 220.6c-22.7 0-41.1-4-41.1-9s18.4-9.1 41.1-9.1c22.7 0 41.1 4.1 41.1 9.1s-18.4 9-41.1 9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m136 211.6-23.1 72.2M136 211.6l23.1 72.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m120.5 260.1 25.7-16.5M125.7 243.6l25.7 16.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "M176.4 133.4c-.1 3.2 0 14.4-.6 19.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M299.3 95.6v-2.3q0-.4.2-.6.1-.3.3-.5.2-.3.5-.4.3-.1.6-.1h14.9q.1.1.2.1.2.1.3.2.1 0 .2.2l5 4.9.2.2q.1.2.1.3.1.1.1.3v24.3q0 .3-.1.6t-.3.5q-.2.2-.5.3-.3.1-.6.1h-3.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M310.3 95.6q.1 0 .3.1.1.1.3.2.1.1.3.2l4.8 4.8q.1.1.2.3.1.1.1.3.1.1.1.3.1.2.1.3v23.7q0 .4-.2.7-.1.3-.3.6-.3.2-.6.3-.3.2-.7.2h-19.1q-.3 0-.7-.2-.3-.1-.5-.3-.3-.3-.4-.6-.1-.3-.1-.7V97.3q0-.3.1-.7.1-.3.4-.5.2-.3.5-.4.4-.1.7-.1H310.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M316.5 101.4H311.2q-.1-.1-.3-.2l-.2-.4q-.1-.1-.1-.3v-4.9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322 97.6h-4.9q-.2 0-.4-.1t-.3-.2q-.1-.1-.2-.3-.1-.2-.1-.4v-4.9",
    style: {
      fill: "#64ccc4"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M258.4 66c0-1.7 1.3-3 3-3h31.4c1.7 0 3.1 1.3 3.1 3v8.8c0 1.7-1.4 3.1-3.1 3.1h-31.4c-1.7 0-3-1.4-3-3.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M272.6 74.4h9l-4.5 13.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M271.9 73.5h-7.5l3.7-6.6zM282.3 66.9h7.5l-3.7 6.6zM277.1 73.1c-1.6 0-2.8-1.3-2.8-2.9 0-1.5 1.2-2.8 2.8-2.8 1.6 0 2.8 1.3 2.8 2.8 0 1.6-1.2 2.9-2.8 2.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M250.4 34c0-1.4 1.2-2.6 2.7-2.6h20.1c1.5 0 2.7 1.2 2.7 2.6v11.5c0 1.5-1.2 2.7-2.7 2.7h-20.1c-1.5 0-2.7-1.2-2.7-2.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m251.2 31.9 12 7.9M275.9 31.4l-12.7 8.4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M275.9 35c-2 0-3.6-1.6-3.6-3.6s1.6-3.7 3.6-3.7 3.6 1.7 3.6 3.7-1.6 3.6-3.6 3.6z"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      transform: "matrix(1,0,0,1,274.843,31.24)"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontSize: 3,
      fill: "#fff",
      fontFamily: "&quot",
      whiteSpace: "pre"
    }
  }, "1\n")), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M307.9 42.7c0-.6.5-1.1 1.1-1.1h94.5c.6 0 1 .5 1 1.1 0 .5-.4 1-1 1H309c-.6 0-1.1-.5-1.1-1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M341.4 2.6c0-1.5 1.2-2.6 2.6-2.6h4c1.4 0 2.5 1.1 2.5 2.6v36.5c0 1.4-1.1 2.5-2.5 2.5h-4c-1.4 0-2.6-1.1-2.6-2.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M350.5 11.9c0-1.2 1-2.1 2.1-2.1h.3c1.2 0 2.2.9 2.2 2.1v27.6c0 1.2-1 2.1-2.2 2.1h-.3c-1.1 0-2.1-.9-2.1-2.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M355.1 11.8c0-1.1.9-2 2-2h.5c1.1 0 2 .9 2 2v27.8c0 1.1-.9 2-2 2h-.5c-1.1 0-2-.9-2-2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M359.7 15.3c-.5-1.1-.1-2.4 1.1-2.9h.1c1.1-.5 2.4-.1 2.9 1l11.5 25c.5 1.1 0 2.4-1.1 2.9l-.2.1c-1.1.5-2.4 0-2.9-1.1zM346 31.1c-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.5 2.6-2.5 1.4 0 2.5 1.1 2.5 2.5s-1.1 2.6-2.5 2.6zM343 33.2c0-.3.3-.6.7-.6h4.6c.3 0 .6.3.6.6 0 .4-.3.6-.6.6h-4.6c-.4 0-.7-.2-.7-.6zM343 36.3c0-.3.3-.6.7-.6h4.6c.3 0 .6.3.6.6 0 .4-.3.7-.6.7h-4.6c-.4 0-.7-.3-.7-.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M296.4 99.1c0-.3.3-.6.6-.6h4.6c.4 0 .7.3.7.6 0 .4-.3.6-.7.6H297c-.3 0-.6-.2-.6-.6zM296.4 102.1c0-.4.3-.7.6-.7h4.6c.4 0 .7.3.7.7 0 .3-.3.6-.7.6H297c-.3 0-.6-.3-.6-.6zM296.2 107.1c0-.3.2-.6.6-.6h16.8c.3 0 .6.3.6.6s-.3.6-.6.6h-16.8c-.4 0-.6-.3-.6-.6zM296.2 110c0-.4.2-.6.6-.6h16.8c.3 0 .6.2.6.6 0 .3-.3.6-.6.6h-16.8c-.4 0-.6-.3-.6-.6zM296.2 112.9c0-.4.2-.6.6-.6h16.8c.3 0 .6.2.6.6 0 .3-.3.6-.6.6h-16.8c-.4 0-.6-.3-.6-.6zM352.3 14.6c0-.3.2-.5.5-.5s.5.2.5.5v22.2c0 .3-.2.5-.5.5s-.5-.2-.5-.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M327.6 44.3c0-.9.7-1.6 1.6-1.6h4.1c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6h-4.1c-.9 0-1.6-.7-1.6-1.6zM377.5 44.3c0-.9.8-1.6 1.7-1.6h4c.9 0 1.7.7 1.7 1.6 0 .9-.8 1.6-1.7 1.6h-4c-.9 0-1.7-.7-1.7-1.6zM197.9 57.8c0-6.6 5.4-12 12-12h15.4c6.6 0 12 5.4 12 12V61c0 6.7-5.4 12-12 12h-15.4c-6.6 0-12-5.3-12-12z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "M206 50.2h6v18.5h-6zM214.6 62.5h5.9v6.2h-5.9zM223.2 57.3h5.9v11.4h-5.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "M248.3 275.2c-.5 2 .9 5.8 1.9 6.6 1.1.7 8.7 2.2 9.5 2.8.8.5.3 2.4-.6 3.3-.9.9-20.7.3-22.5-.6-1.8-.9-.9-10.6-.9-12.1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.8 153.6c-8-.5-17.2-1.4-17.2-1.4l-42-2.9s-35.8-6.6-35.8-19.2c0-12.7 2.5-48.9 10.3-56.7 2.5-2.5 12.4-6.4 45.9-6.4 5.6 0 37 2.8 38.6 4.4 6.7 6.8 11.5 52.2 12 72.6l-11.2 4s-.5 3.2-.6 5.6z",
    style: {
      fill: "#69d2c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.6 159.8c3.1-.9 33.5-5.9 40.1.6 6.6 6.5 27.4 99.8 27.4 102h-16.8l-22.6-48.7",
    style: {
      fill: "#145c90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6 157.2c18.1 12.2 28.1 119.4 28.1 119.4h-16.1c-.2-1.6-35.3-73.2-37.2-76.4-2.9 1.4-45.4 9.2-71.7 9.2-8.4 0-31.9-.6-31.9-29.3 0-20.7 4.6-24.8 5.3-28.6 13.5-2.3 117.7 1.8 123.5 5.7z",
    style: {
      fill: "#207bbd"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "M211.3 141.4c0 2.9-4.9 5-7.6 5-3.9 0-7.3-3.4-13.9-3.4-2.7 0-4.8 5.1-13.9 8.8l.5-18.4c9.6-1.9 13.1-2.9 17.4-2.9 5.2 0 17.5 4.8 17.5 10.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "M273.9 261.1c-.5 2 .9 5.9 2 6.6 1 .7 8.7 2.3 9.5 2.8.7.5.2 2.4-.7 3.3-.9.9-20.7.4-22.5-.5-1.8-.9-.9-10.6-.9-12.2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "M142.9 71.4c0 2.4-14.3 2.5-14.3 0v-20h14.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "M138.2 58c-1.3 0-9.6 3.7-9.6 5.7V52.9c2.1 0 9.6 5.1 9.6 5.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "M141 58.8c-9.5 0-17.3-7.7-17.3-17.2s7.8-17.3 17.3-17.3 17.2 7.8 17.2 17.3-7.7 17.2-17.2 17.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "M158.8 28.1c-2.1 3.3-6.6 4.9-11.4 4.9-4.2 0-10.2-1.2-14.4 1.2-2.3 1.3-5 4.3-5.5 10.2 0 1-1.2 5-1.2 6.3 0 .8-.9 1.4-2.6 1.4-.8 0-2.5-1.4-2.5-3.4 0-2.4 1-3.3 1-5.3 0-2.1-2.5-4-2.5-9.7 0-8.2 5.2-13.2 8.9-13.2 3.3 0 4.4.8 4.8 1.1 0-7.4 9.8-10.8 13.7-10.8 4.4 0 6.5 1.8 6.5 4.2 0 3.6-1.8 6.8-2.7 7.5q.8-.7 1.6-1.2.9-.6 1.8-.9 1-.4 2-.6 1-.1 2-.1c5 0 6.7 3.3 6.7 5.6 0 4.9-5.9 9.5-8.1 9.5q-.2-.4-.4-.9-.3-.4-.5-.8-.3-.4-.5-.8-.3-.5-.6-.9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "M128 47.5c-2 0-3.7-1.6-3.7-3.6 0-2.1 1.7-3.7 3.7-3.7s3.7 1.6 3.7 3.7c0 2-1.7 3.6-3.7 3.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "M158.4 44.8c-1.6 0-2.8-.7-2.8-1.5s1.2-1.5 2.8-1.5c1.6 0 2.9.7 2.9 1.5s-1.3 1.5-2.9 1.5zM140.5 44.8c-1.6 0-2.9-.7-2.9-1.5s1.3-1.5 2.9-1.5c1.6 0 2.8.7 2.8 1.5s-1.2 1.5-2.8 1.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "M151.4 40.2c.6.8 3.3 4 .4 5.2M146.1 49.2c-.9 0-2.2-1.1-2.9-2M168.8 95.5c1.3 2.8 7.6 29.5 7.6 37.9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "M113.7 127.9c-.3.7-2.6 8.9-2.6 12.4 0 1.9 1.9 2.4 3.1 2.4 1.1 0 48.3-11.4 60.1-11.4 5.3 0 17.6 4.8 17.6 10.9 0 2.9-4.9 5-7.6 5-3.9 0-7.3-3.4-13.9-3.4-7.5 0-49.5 22.8-77.2 22.8-12.1 0-12.4-8.7-12.4-38.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "M120.6 101.7c-.8 2.3-7 25.9-7.7 28.8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M362 282.6c.5 1.8-.6 3.6-2.3 4.1-1.8.5-3.6-.6-4.1-2.4l-33.3-126.7c-.5-1.8.6-3.6 2.4-4.1 1.8-.4 3.6.6 4.1 2.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M315.5 155.9c.5-1.8 2.3-2.9 4.1-2.4 1.7.5 2.8 2.3 2.3 4.1l-33.2 126.7c-.5 1.8-2.3 2.9-4.1 2.4-1.8-.5-2.9-2.3-2.4-4.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M269.5 155.9c.5-1.8 2.3-2.9 4.1-2.4 1.8.5 2.8 2.3 2.4 4.1l-33.3 126.7c-.5 1.8-2.3 2.9-4.1 2.4-1.8-.5-2.8-2.3-2.4-4.1zM315.5 280.3c.5 1.8-.6 3.6-2.4 4.1-1.8.4-3.6-.6-4.1-2.4l-32.7-127.1c-.5-1.8.6-3.6 2.4-4.1 1.8-.5 3.6.6 4 2.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M81.8 155.9c.5-1.8 2.3-2.9 4.1-2.4 1.7.5 2.8 2.3 2.3 4.1L55 284.3c-.5 1.8-2.3 2.9-4.1 2.4-1.8-.5-2.9-2.3-2.4-4.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M127.8 282.6c.4 1.8-.6 3.6-2.4 4.1-1.8.5-3.6-.6-4.1-2.4L88 157.6c-.4-1.8.6-3.6 2.4-4.1 1.8-.4 3.6.6 4.1 2.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M17.2 151.8c0-2.5 2.1-4.5 4.6-4.5h319.1c2.5 0 4.5 2 4.5 4.5v.8c0 2.5-2 4.5-4.5 4.5H21.8c-2.5 0-4.6-2-4.6-4.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M34.2 155.9c.4-1.8 2.3-2.9 4-2.4 1.8.5 2.9 2.3 2.4 4.1L7.3 284.3c-.4 1.8-2.3 2.9-4 2.4-1.8-.5-2.9-2.3-2.4-4.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M80.1 282.6c.5 1.8-.5 3.6-2.3 4.1-1.8.5-3.6-.6-4.1-2.4L40.4 157.6c-.5-1.8.6-3.6 2.4-4.1 1.8-.4 3.6.6 4.1 2.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M258.5 147.3h-60.2l10.9-37.6q.2-.6.6-1.2.4-.6 1-1t1.2-.7q.7-.2 1.4-.2h51.1q1 0 1.9.4 1 .5 1.6 1.3.6.8.8 1.8.2 1-.1 2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M235.8 130.6c-2.1 0-3.7-1.6-3.7-3.7 0-2 1.6-3.6 3.7-3.6 2 0 3.7 1.6 3.7 3.6 0 2.1-1.7 3.7-3.7 3.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M163.2 144.6h42.2v2.7h-42.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.d64092b0e05393697d5173c89a683425.svg";
export { ForwardRef as ReactComponent };